import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from './../api/api';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { StorageWraperProvider } from '../storage-wraper/storage-wraper';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the AuthenticationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthenticationProvider {
  logedIn = new BehaviorSubject<boolean>(true);

  constructor(public api: Api, public storage: StorageWraperProvider) {}

  atemptAuth(username: string, password: string): void {
    const credentials = { username: username, password: password };
    this.api.post('session/login', credentials);
  }
  isAuthenticated(): boolean {
    let user = this.storage.get('currentUser');
    if (user) {
      return true;
    }
    return false;
  }
  refreshToken(currentToken) {
    return this.api.get('token/refresh', currentToken);
  }

  verifyPassword(
    password: string,
    email: string
  ): Observable<any> {
    return this.api
      .post('sessions/verify', {
        password: password,
        email: email,
      })
      .map(res => {
        return res;
      });
  }

}



// WEBPACK FOOTER //
// ./src/providers/authentication/authentication.ts